import { useEffect } from 'react';
export default function useAutoclose({
  onClose,
  autoClose,
  open,
  timeoutMs
}) {
  useEffect(() => {
    if (!autoClose || !open) return undefined;
    const handle = setTimeout(onClose, timeoutMs);
    return () => {
      clearTimeout(handle);
    };
  }, [onClose, autoClose, open, timeoutMs]);
}